// The built-in legal copy as data, so the same text can be rendered on the page and loaded into
// the admin editor for real editing (not just appending).
export const legalDefaults = (kind, t) => {
  // The billing/refund terms live inside the Terms of Use now — one page to read, one to accept.
  const refundSections = [
    { title: t("lg.whatLytepressChargesFor"), body: `${t("lg.lytepressOnlyEverCharges")} businesses, for three things: a ${t("lg.proSubscription")} (monthly or yearly), a Boost ${t("lg.onASingleDeal")} Featured ${t("lg.placementShoppersUseLytepress")}` },
    { title: t("lg.dealsAreNotSold"), body: `${t("lg.shoppersNeverPayUs")}\n\n${t("lg.ifABusinessRefuses")}` },
    { title: t("lg.proSubscriptionsDayMoney"), body: `${t("lg.ifYouReNot")} 14 days ${t("lg.ofThePaymentAnd")}\n\n${t("lg.afterDaysASubscription")}\n\n${t("lg.ifARenewalCharge")}` },
    { title: t("lg.quotasAndCredits"), body: t("lg.quotasAndCreditsBody") },
    { title: t("lg.boostsAndFeaturedPlacements"), body: `${t("lg.boostsIntro")}\n\n${t("lg.boostStartsNowLabel")} ${t("lg.boostStartsNow")}\n\n${t("lg.ifAPlacementFailed")}` },
    { title: t("lg.howToRequestA"), body: `${t("lg.emailUsFromThe")}\n\n${t("lg.refundTimeline")}` },
    { title: t("lg.taxesCurrencyAndFees"), body: t("lg.refundsIncludeAnyTax") },
    { title: t("lg.chargebacks"), body: t("lg.pleaseTalkToUs") },
    { title: t("lg.cancellingYourAccount"), body: t("lg.youCanStopUsing") },
  ];
  if (kind === "refunds") {
    return { intro: t("lg.plainSummary"), sections: [...refundSections, { title: t("lg.contact"), body: t("lg.billingQuestionsReachUs") }] };
  }
  if (kind === "terms") {
    return {
      intro: `${t("lg.plainSummary")}\n\n${t("lg.asIsShort")}`,
      sections: [
        { title: t("lg.usingLytepress"), body: t("lg.lytepressHelpsShoppersDiscover") },
        { title: t("lg.accounts"), body: `${t("lg.youAreResponsibleFor")}\n\n${t("lg.passwordRules")}` },
        { title: t("lg.dealsRedemptions"), body: `${t("lg.dealsAreOfferedBy")}\n\n${t("lg.notResponsibleForDeals")}\n\n${t("lg.quotaTerms")}` },
        { title: t("lg.payments"), body: `${t("lg.premiumSubscriptionsAndDeal")} ${t("lg.refundPolicy")}, ${t("lg.setOutBelow")}.` },
        ...refundSections,
        { title: t("lg.aiHelp"), body: t("lg.aiHelpBody") },
        { title: t("lg.emailsWeSend"), body: t("lg.emailsWeSendBody") },
        { title: t("lg.location"), body: t("lg.ipAndGeo") },
        { title: t("lg.analyticsTitle"), body: t("lg.analyticsBody") },
        { title: t("lg.acceptableUse"), body: `${t("lg.donTPostUnlawful")}\n\n${t("lg.listingDiscretion")}` },
        { title: t("lg.asIsTitle"), body: t("lg.asIsBody") },
        { title: t("lg.availabilityTitle"), body: t("lg.availabilityBody") },
        { title: t("lg.forceMajeureTitle"), body: t("lg.forceMajeureBody") },
        { title: t("lg.changesTermination"), body: t("lg.weMayUpdateThese") },
        { title: t("lg.deletingYourAccount"), body: `${t("lg.deleteShopper")}\n\n${t("lg.deleteBusiness")}\n\n${t("lg.deleteAdmin")}` },
        { title: t("lg.lawDisputes"), body: t("lg.lawDisputesBody") },
        { title: t("lg.termsContact"), body: t("lg.questionsAboutTheseTerms") },
      ],
    };
  }
  return {
    intro: t("lg.plainSummary"),
    sections: [
      { title: t("lg.whoWeAre"), body: t("lg.whoWeAreBody") },
      { title: t("lg.informationWeCollect"), body: `${t("lg.accountDetailsNameEmail")}\n\n${t("lg.collectLangEmail")}` },
      { title: t("lg.howWeUseIt"), body: t("lg.toRunTheService") },
      { title: t("lg.location"), body: `${t("lg.ifYouUseNear")}\n\n${t("lg.ipAndGeo")}` },
      { title: t("lg.sharing"), body: `${t("lg.businessContactDetailsAre")}\n\n${t("lg.listingModerationRecords")}\n\n${t("lg.sharingAi")}` },
      { title: t("lg.analyticsTitle"), body: t("lg.analyticsBody") },
      { title: t("lg.security"), body: `${t("lg.passwordsAreHashedFa")}\n\n${t("lg.breachCheckPrivacy")}` },
      { title: t("lg.emailsWeSend"), body: t("lg.privacyEmailChoices") },
      { title: t("lg.yourChoices"), body: t("lg.youCanEditYour") },
      { title: t("lg.contact2"), body: t("lg.privacyQuestionsReachUs") },
    ],
  };
};

export default legalDefaults;
